/**
 * Функция для склонений
 * @param {number} number -число
 * @param {Array} titles - варианты слов
 * @return {string}
 * Usage example:
 * pluralize(10, ["Реестр", "Реестра", "Реестров"])
 */
export const pluralize = (number: number, titles: string[]) => {
    const cases = [2, 0, 1, 1, 1, 2];
    const titleIndex = number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5];
    return titles[titleIndex] || titles[titles.length - 1];
};
